<template>
  <v-card class="section-card pa-6 mt-6" elevation="0">
    <div class="d-flex align-center mb-6">
      <div class="icon-circle mr-4">
        <v-icon color="#2563eb">mdi-qrcode-scan</v-icon>
      </div>
      <div>
        <h3 class="text-h6 font-weight-bold mb-0">ตั้งค่าการรับชำระเงิน (PromptPay)</h3>
        <p class="text-caption grey--text mb-0">ข้อมูลสำหรับการสร้าง QR Code และตรวจสอบสลิปอัตโนมัติ</p>
      </div>
    </div>

    <v-form ref="form">
      <v-row>
        <v-col cols="12" md="4">
          <span class="detail-label">PromptPay ID</span>
          <v-text-field v-model="form.promptPayId" placeholder="เบอร์โทรศัพท์ หรือ เลขบัตรประชาชน" outlined dense
            hide-details="auto" class="mt-1" prepend-inner-icon="mdi-numeric"></v-text-field>
          <p class="text-caption grey--text mt-1">ใช้สำหรับสร้าง QR Code รับเงิน</p>
        </v-col>

        <v-col cols="12" md="4">
          <span class="detail-label">ชื่อจริง (ภาษาไทย)</span>
          <v-text-field v-model="form.natId_firstName" placeholder="ชื่อจริง (ภาษาไทย)" outlined dense
            hide-details="auto" class="mt-1"></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <span class="detail-label">นามสกุล (ภาษาไทย)</span>
          <v-text-field v-model="form.natId_lastName" placeholder="นามสกุล (ภาษาไทย)" outlined dense hide-details="auto"
            class="mt-1"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="4">
          <!-- Placeholder to align with row above if needed -->
        </v-col>
        <v-col cols="12" md="4">
          <span class="detail-label">ชื่อจริง (ภาษาอังกฤษ)</span>
          <v-text-field v-model="form.natId_firstName_en" placeholder="First Name (English)" outlined dense
            hide-details="auto" class="mt-1"></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <span class="detail-label">นามสกุล (ภาษาอังกฤษ)</span>
          <v-text-field v-model="form.natId_lastName_en" placeholder="Last Name (English)" outlined dense
            hide-details="auto" class="mt-1"></v-text-field>
        </v-col>
      </v-row>

      <v-alert type="info" text dense class="mt-4 mb-0" border="left" icon="mdi-information-outline">
        <span class="text-caption">
          กรุณากรอกชื่อ-นามสกุลภาษาอังกฤษให้ตรงกับหน้าสมุดบัญชี
          เพื่อใช้ในการตรวจสอบชื่อผู้รับเงินเมื่อลูกค้าอัปโหลดสลิป
        </span>
      </v-alert>

      <div class="d-flex justify-end mt-6">
        <v-btn color="#2563eb" dark depressed @click="save" :loading="loading" min-width="120" height="40"
          style="border-radius: 8px; text-transform: none;">
          บันทึกข้อมูลการเงิน
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
export default {
  name: "PromptPayCard",
  props: {
    data: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      form: {
        promptPayId: "",
        natId_firstName: "",
        natId_lastName: "",
        natId_firstName_en: "",
        natId_lastName_en: ""
      }
    };
  },
  watch: {
    data: {
      immediate: true,
      handler(v) {
        if (!v) return;
        this.form = {
          promptPayId: v.promptPayId || "",
          natId_firstName: v.natId_firstName || "",
          natId_lastName: v.natId_lastName || "",
          natId_firstName_en: v.natId_firstName_en || "",
          natId_lastName_en: v.natId_lastName_en || ""
        };
      }
    }
  },
  methods: {
    save() {
      this.$emit("save", { ...this.form });
    }
  }
};
</script>

<style scoped>
.section-card {
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
}

.icon-circle {
  width: 44px;
  height: 44px;
  background: #eff6ff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-label {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
}

:deep(.v-text-field--outlined fieldset) {
  border-color: #e2e8f0;
}

:deep(.v-text-field--outlined.v-input--is-focused fieldset) {
  border-color: #2563eb;
}
</style>
